module.exports = __webpack_public_path__ + "img/redTrash.06736aed.svg";